module.exports = __webpack_public_path__ + "img/admin-links.8a3ac5e6.svg";